import { DEMO_APPOINTMENTS } from '../lib/demo-data';

export default function Agenda() {
  return (
    <div>
      <h1 className="h3 mb-1">Agenda</h1>
      <p className="text-muted small mb-4">
        Visualização de demonstração — sincronização com calendário na Fase 2.
      </p>

      <div className="card shadow-sm">
        <div className="list-group list-group-flush">
          {DEMO_APPOINTMENTS.map((c) => (
            <div
              key={c.id}
              className="list-group-item d-flex align-items-center gap-3 py-3"
            >
              <div
                className="rounded-3 text-center px-2 py-1 flex-shrink-0"
                style={{
                  minWidth: 64,
                  background:
                    c.status === 'proxima'
                      ? 'rgba(34,197,94,0.12)'
                      : 'rgba(0,0,0,0.04)',
                }}
              >
                <div className="small fw-bold">{c.date}</div>
                <div className="fw-bold">{c.time}</div>
              </div>
              <div className="flex-grow-1">
                <div className="fw-semibold">{c.baby}</div>
                <div className="small text-muted">{c.type}</div>
              </div>
              <span
                className={`badge rounded-pill ${
                  c.status === 'proxima' ? 'text-bg-success' : 'text-bg-secondary'
                }`}
              >
                {c.status === 'proxima' ? 'Próxima' : 'Realizada'}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
